export default {
  metaInfo () {
    return {
      title: this.getTitle(),
      titleTemplate: '%s | СТО Автодизель г.Донецк',
      meta: [{ name: 'description', content: this.getDescription() }]
    }
  },
  methods: {
    getTitle: function () {
      if (this.service) {
        return this.service.title
      }
      return this.title
    },
    getDescription: function () {
      if (this.service) {
        return this.service.info
      }
      return this.content
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/get-meta.js